module.exports = __webpack_public_path__ + "static/Calibre-MediumItalic-3df14639dd2cb07c83bd39707d70910f.woff2";